/**
 * @override King Living — GlobalConfig includes My Account landing Contentful references.
 *
 * Contentful field API IDs:
 * - accountSuggestedForYou (ProductTiles)
 * - accountGetInspired (BlogRelatedArticles / CF-050)
 * - accountOrderHistoryFaq (AccordionPanel / CF-018)
 * - accountShopNowLink (Link — empty-state Shop now CTA)
 */

import gql from 'graphql-tag';

import {AccordionPanelFragment} from '@amblique/contentful/app/contentful/fragments/accordion-panel/accordion-panel.fragment';
import {BaseBlogRelatedArticlesFragment} from '@amblique/contentful/app/contentful/fragments/blog-related-articles/base-blog-related-articles.fragment';
import {BaseGlobalConfigFragment} from '@amblique/contentful/app/contentful/fragments/global-config/base-global-config.fragment';
import {BaseHeroBannerFragment} from '@amblique/contentful/app/contentful/fragments/hero-banner/base-hero-banner.fragment';
import {BaseIconFragment} from '@amblique/contentful/app/contentful/fragments/icon/base-icon.fragment';
import {BaseImageFragment} from '@amblique/contentful/app/contentful/fragments/image/base-image.fragment';
import {BaseLinkFragment} from '@amblique/contentful/app/contentful/fragments/link/base-link.fragment';
import {BaseProductTilesFragment} from '@amblique/contentful/app/contentful/fragments/product-tiles/base-product-tiles.fragment';

export const GlobalConfigFragment = gql`
  ${AccordionPanelFragment}
  ${BaseGlobalConfigFragment}
  ${BaseHeroBannerFragment}
  ${BaseIconFragment}
  ${BaseImageFragment}
  ${BaseLinkFragment}
  ${BaseProductTilesFragment}
  ${BaseBlogRelatedArticlesFragment}

  fragment GlobalConfigFragment on GlobalConfig {
    ...BaseGlobalConfigFragment

    accountHero {
      ...BaseHeroBannerFragment
    }
    accountSuggestedForYou {
      ...BaseProductTilesFragment
    }
    accountGetInspired {
      ...BaseBlogRelatedArticlesFragment
    }
    accountOrderHistoryFaq {
      ...AccordionPanelFragment
    }
    accountShopNowLink {
      ...BaseLinkFragment
    }
    cartPaymentIconsCollection {
      items {
        __typename
        ... on Icon {
          ...BaseIconFragment
        }
      }
    }
    cartPaymentIconsCursorCollection {
      items {
        __typename
        ... on Icon {
          ...BaseIconFragment
        }
      }
    }
    loginImage {
      ...BaseImageFragment
    }
    showroomHero {
      ...BaseHeroBannerFragment
    }
    signUpImage {
      ...BaseImageFragment
    }
    socialLinksCollection {
      items {
        __typename
        ... on Link {
          ...BaseLinkFragment
        }
      }
    }
    socialLinksCursorCollection {
      items {
        __typename
        ... on Link {
          ...BaseLinkFragment
        }
      }
    }
  }
`;
